<div class="curva-abc-venda-table table-responsive">
    <table class="table table-striped table-hover table-bordered" #tableElement>
        <thead>
            <tr>
                <th class="col-codigo-integracao">Código</th>
                <th class="col-nome">Nome</th>
                <th class="col-quantidade text-right">Quantidade</th>
                <th class="col-quantidade-convertida text-right" title="Quantidade Convertida">Quantidade Conv.</th>
                <th class="col-peso text-right">Peso</th>
                <th class="col-valor text-right">Valor</th>
                <th class="col-preco-medio text-right">Preço Médio</th>
                <th class="col-preco-medio-convertido text-right" title="Preço Médio Convertido">Preço Médio Conv.</th>
                <th class="col-perc-participacao text-right" title="Participação">Part.</th>
                <th class="col-quantidade-media text-right">Quantidade Média</th>
                <th class="col-quantidade-convertida-media text-right" title="Quantidade Convertida Média">Quantidade Conv. Média</th>
                <th class="col-peso-medio text-right">Peso Médio</th>
                <th class="col-valor-medio text-right">Valor Médio</th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td class="text-center" colspan="2">
                    {{curvaAbcVenda?.quantidadeRegistros | decimalFormat: 1:0:0}} {{perspectiva?.nome}}
                </td>
                <td class="col-quantidade text-right">{{curvaAbcVenda?.quantidadeTotal | decimalFormat: 1:2:2}}</td>
                <td class="col-quantidade-convertida text-right">{{curvaAbcVenda?.quantidadeConvertidaTotal | decimalFormat: 1:2:2}}</td>
                <td class="col-peso text-right">{{curvaAbcVenda?.pesoTotal | decimalFormat: 1:2:2}}</td>
                <td class="col-valor text-right">{{curvaAbcVenda?.valorTotal | decimalFormat: 1:2:2}}</td>
                <td class="col-preco-medio text-right"></td>
                <td class="col-preco-medio-convertido text-right"></td>
                <td class="col-perc-participacao text-right"></td>
                <td class="col-quantidade-media text-right">{{curvaAbcVenda?.quantidadeMedia | decimalFormat: 1:2:2}}</td>
                <td class="col-quantidade-convertida-media text-right">{{curvaAbcVenda?.quantidadeConvertidaMedia | decimalFormat: 1:2:2}}</td>
                <td class="col-peso-medio text-right">{{curvaAbcVenda?.pesoMedio | decimalFormat: 1:2:2}}</td>
                <td class="col-valor-medio text-right">{{curvaAbcVenda?.valorMedio | decimalFormat: 1:2:2}}</td>
            </tr>
        </tfoot>
    </table>    
</div>